module.exports = __webpack_public_path__ + "assets/img/00020.5dc746d3.png";